export class TbaConstants {
  public static readonly TBA_PARAMETERS_UNIT_PRICE = 'Unit Price';
  public static readonly TBA_PARAMETERS_COGS_RELATED = 'COGS (related)';
  public static readonly TBA_PARAMETERS_COGS_UNRELATED = 'COGS (unrelated)';
  public static readonly TBA_PARAMETERS_RESALE_PRICE = 'Resale Price';
  public static readonly TBA_PARAMETERS_SALES_PRICE = 'Sales Price';

  public static readonly TBA_PARAMETERS_ROYALTY = 'Royalty';
  public static readonly TBA_PARAMETERS_INTEREST = 'Interest';
  public static readonly TBA_PARAMETERS_SERVICE = 'Service';
  
  public static readonly TBA_PARAMETERS_GROSS_PROFIT_MARKUP: 'Gross Profit Markup';
  public static readonly TBA_PARAMETERS_GROSS_PROFIT_MARGIN: 'Gross Profit Margin';

}
